import { Dashboard } from '@leverege/ui-dashboard';
import I18N from '@leverege/i18n';
import DashboardView from "./DashboardView.js";
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.dashboard.DashboardDataViewer');
export default {
  id: 'molten.dataViewer.dashboard.DashboardDataViewer',
  type: 'molten.Dashboard',
  name: tf('dashboardViewer'),
  icon: tfIcon('configIcon'),
  layout: {
    section: tf('section'),
    sort: 'e.a'
  },
  location: 'main',
  allowMultiple: true,
  matches: {
    type: ['GroupDataViewer', 'ItemInfoDataViewer']
  },
  component: DashboardView,
  settingsUpdaters: DataViewerModelUpdaterCreator.create('DashboardViewModelUpdater'),
  createSettings: props => {
    return Dashboard.create();
  },
  reset: async props => {
    const {
      settingsData,
      onSettingsChange
    } = props;
    if (onSettingsChange) {
      onSettingsChange({
        value: Dashboard.create(),
        data: settingsData
      });
    }
    // await UserSettings.reset( props.settingsPath )
  }
};